// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3SDcI","dragIcon":"Choice_dragIcon__3GxZd","left":"Choice_left__3DwVs","input":"Choice_input__2BBB0"};